import { createAction, props } from '@ngrx/store';
import { MeasurementToolState } from '../measurement-tools-collection.state';

/** Dispatched by `MeasurementToolsNgrxService.init()` to trigger cache rehydration and backend load. */
export const initMeasurementTools = createAction('[MeasurementTools] Init');

/**
 * Dispatched once the backend tools have been loaded. Populates the slice and triggers
 * a persist of the slice to storage.
 */
export const measurementToolsLoaded = createAction(
    '[MeasurementTools] Loaded',
    props<{ tools: MeasurementToolState[] }>(),
);

/**
 * Dispatched by the persistence bridge with the tools read back from storage. Populates
 * the slice like {@link measurementToolsLoaded} but does not trigger a re-persist.
 */
export const measurementToolsLoadedFromStorage = createAction(
    '[MeasurementTools] Loaded from storage',
    props<{ tools: MeasurementToolState[] }>(),
);

/** Dispatched when the backend request fails. Transitions the slice to {@link LoadStatus.Error}. */
export const measurementToolsFailed = createAction('[MeasurementTools] Failed');
